<template>
  <div class="article-swiper swiper-element" v-if="claims">
    <swiper
      :slidesPerView="1.4"
      :spaceBetween="20"
      :breakpoints="{
      '640': {
        slidesPerView: 2.4,
        spaceBetween: 20,
      },
      '768': {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      '1024': {
        slidesPerView: 4,
        spaceBetween: 20,
      },
     }"
      :centeredSlides="claims.length <= 2"
      :grabCursor="true"
			:pagination="{
				clickable: true,
			}"
			:modules="modules"
      :style="{
        '--swiper-navigation-color': '#07034A',
        '--swiper-pagination-color': '#FFFFFF',
      }"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
      @afterInit="onSlideInit"
      class="knd-swiper"
    >
      <swiper-slide
        class="knd-article__slide"
        v-for="(article, index) in claims"
        :class="{ 'knd-slide__even': index % 2 === 0 }"
        :key="index + '-article'"
      >
        <article class="knd-article">
          <div class="knd-article__content">
            <div class="knd-article--text">
              {{ article['text'] }}
            </div>
          </div>
					<a v-if="article['link']" class="knd-article--link" :href="article['link']" target="_blank">
						Link
          </a>
        </article>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import {  Pagination } from 'swiper/modules';
import { mapGetters } from "vuex";

import 'swiper/css';
import 'swiper/css/pagination';


export default {
  name: "ArticleSwiper",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      selected: undefined,
      assetsUrl: process.env.VUE_APP_ASSETS,
			modules:[Pagination]
    };
  },
  computed: {
    ...mapGetters(["claims"])
  },
  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSlideChange() {},
    onSlideInit() {},

    gotoProject(url) {
      window.open(url);
    },
  },
};
</script>


<style lang="scss">

.knd-swiper {
  padding-bottom: 30px !important;
}

.article-swiper {
	height: 100%;
	width: 100%;
	position: relative;
  
	.swiper-container {
    width: 100%;
    height: 100%;
    // padding-bottom: 50px;
	}

  .knd-article__slide {
    height: auto !important;
  }

	.swiper-wrapper {
			padding-bottom: 0;
	}

	.knd-article {
			margin: 0 auto;
			cursor: pointer;
			position: relative;
			height: 100%;
			width: 100%;
      display: flex;
    flex-direction: column;
	}

	.knd-article__content {
			padding: 1rem 1rem !important;
			background: var(--jade);
			color: var(--moss);
      flex: 1 0 auto; 
	}

	.knd-article--link {
		background: var(--moss);
		padding: 1rem 1rem !important;
		
		color: var(--off-white);
		text-decoration: underline;
	}

	.swiper-pagination {
    --swiper-pagination-bullet-inactive-color: #CCC;
    --swiper-pagination-color: #000;
			bottom: 0;
      // padding-bottom: 30px;

			.swiper-pagination-bullet {
				opacity: 1;
			}
	}
}
</style>